<template>
	<div class="mod" @click="scrollView" :id="getDomId">
		<label class="remove-margin color-6f7 font-14 m-d-4" v-if="title !== ''" :class="{ require: required }">
			{{ title }}
		</label>
		<!-- <Select2
			class="test-select fl-is-required inputs"
			:options="options"
			v-model="selected"
			:settings="select2Settings"
			:debug="true"
			@change="optionSelected"
			@select="mySelectEvent($event)"
			multiple="multiple"
			@hook:mounted="customStyle"
			:disabled="disabled"
		/> -->
		<v-select
			:options="mappedOptions"
			label="text"
			@input="v => !v.isParent && $emit('option-selected', v.id)"
			:value="mappedOptions.find(option => option.id === selected)"
			:placeholder="placeholder"
		>
			<template #list-header>
				<div class="border-top"/>
			</template>
			<template #option="{text, isParent}">
				<p :class="{ 'f-c-midgrey': isParent }" style="margin: 0">{{ text }}</p>
			</template>
		</v-select>
		<!--
		   untuk v-select type data untuk option wajib [
		   {
		   	id: "",
		   	text: "",
		   }
		   ] 
		 -->
	</div>
</template>

<script>
// props options example
// options: [
// {
// 	id: "",
// 	text: "",
// }
// ]

import Select2 from "v-select2-component";
import {regex} from "@/store/utils/vars";

export default {
	name: "SOInputSelect",
	components: {Select2},
	props: [
		"title",
		"placeholder",
		"options",
		"selected",
		"required",
		"disabled",
	],
	mounted() {
		this.customStyle()
		setTimeout(function () {
			$(".select2-selection").click(function () {
				$(".select2-search__field").keyup(function () {
					let strRegex = $(".select2-search__field").val().replace(regex.alphanumeric, "")
					$(".select2-search__field").val(strRegex)
				})
			})
		}, 500)
	},
  computed: {
    getDomId() {
      return this.title ? this.title.replace(/\s/g, '-') : 'select2-' + crypto.randomUUID()
    },
		mappedOptions() {
			let options = []
			this.options.forEach((option) => {
				if (option.children) {
					options.push({
						id: option.id,
						text: option.text,
						isParent: true,
					})
					option.children.forEach((child) => {
						options.push({
							id: child.id,
							text: child.text,
							group: option.text,
						})
					})
				} else {
					options.push({
						id: option.id,
						text: option.text,
					})
				}
			})
			return options
		},
  },
	methods: {
		customStyle() {
			let el = document.getElementById("select2--container");
			el.style.lineHeight = "24px";
		},
		optionSelected() {
			this.$emit("option-selected", this.selected);
		},
		mySelectEvent({id, text}) {
			this.selected.push(id);
		},
    scrollView() {
      let el = document.getElementById(this.getDomId);
          el.scrollIntoView();

          document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
    }
	},
};
</script>
<style scoped>
.mod >>> .vs__dropdown-toggle {
	padding: 6px;
}
</style>
